<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/h-SiC/h-SiC.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">塑封半桥碳化硅功率模块</div>
                <div class="detail-banner-desc">专利Layout布局，支持4-8芯并联，宽功率等级，覆盖150-300kW。</div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">产品说明</div>

                    <div class="detail-desc">
                        <div>
                            高工作结温，Tjop=175℃<br />
                        </div>
                        <div>
                            高效散热Pin-fin，比同类热阻降低10%<br />
                        </div>
                        <div>
                            专利Layout布局，支持4-8芯并联<br />
                        </div>
                        <div>
                            宽功率等级，覆盖150-300kW<br />
                        </div>
                        <div>
                            低寄生电感＜5nH，支持900V工作电压<br />
                        </div>
                        <div>
                            应用领域：车规主驱
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    核心配置
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/h-SiC/h-SiC-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">750V/1200V</div>
                                    <div class="k">额定电压</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1.1-2.8mΩ</div>
                                    <div class="k">导通电阻</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">400V/800V</div>
                                    <div class="k">应用电压平台</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">350-825Arms</div>
                                    <div class="k">出流能力</div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '塑封半桥碳化硅功率模块 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'electronics/h-SiC.html'
};

import { createApp } from 'vue';
import App from './h-SiC.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./h-SiC.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
